export default __webpack_public_path__ + "static/media/teamleader.495db370.jpg";